import React, { Component } from 'react';
import { connect } from 'react-redux';
import Sound from 'react-sound';
import anime from 'animejs'

import PlayIcon from './play-icon';
import { playSound, pauseSound } from '../../modules/app';

import './style.css';

class AudioPlayer extends Component {
    constructor(props) {
        super(props);

        this.state = {
            playing: false
        };
    }

    componentWillReceiveProps(nextProps) {
        const { isPlaying } = nextProps;

        if (!isPlaying) {
            if (!this.leftBar.reversed) this.leftBar.reverse();
            if (!this.rightBar.reversed) this.rightBar.reverse();
        } else {
            if (this.leftBar.reversed) this.leftBar.reverse();
            if (this.rightBar.reversed) this.rightBar.reverse();
        }

        this.leftBar.play();
        this.rightBar.play();
    }

    componentDidMount() {
        this.leftBar = anime({
            targets: '#leftbar',
            points: '42 33 67 33 67 112 42 112',
            easing: 'easeInOutExpo',
            duration: 250,
            autoplay: false
        });

        this.rightBar = anime({
            targets: '#rightbar',
            points: '77 33 102 33 102 73 102 112 77 112',
            easing: 'easeInOutExpo',
            duration: 250,
            autoplay: false
        });
    }

    controlClicked = () => {
        const { dispatch, isPlaying } = this.props;
        
        if (!isPlaying) {
            dispatch(playSound());
        } else {
            dispatch(pauseSound());
        }
    };

    render() {
        const { data, isPlaying } = this.props;
        const sound = require(`../../sound/${data.sound}.mp3`);
        const playStatus = isPlaying ? Sound.status.PLAYING : Sound.status.PAUSED;
        
        return (
            <div className="sound-player">
                <button onClick={this.controlClicked}>
                    <PlayIcon />
                </button>
                <Sound 
                    url={sound}
                    loop
                    playStatus={playStatus}
                />
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        isPlaying: state.app.isPlaying
    };
}

export default connect(mapStateToProps)(AudioPlayer);



// WEBPACK FOOTER //
// ./src/components/AudioPlayer/index.js